
/* eslint-disable @typescript-eslint/no-shadow */
export namespace RankingGraphTypeV1 {
  export enum RankingGraphTypeV1 {
    STACKED_COLUMN = "STACKED_COLUMN",
    GROUPED_BAR = "GROUPED_BAR",
    NONE = "NONE",
  }

  export interface RankingGraphTypeV1DTO {
    case: string;
  }

  export const fromDTO = (dto: RankingGraphTypeV1DTO): RankingGraphTypeV1 => {
    if (dto === undefined || dto === null) {
      throw new InvalidRankingGraphTypeV1Error(
        `Invalid DTO ${dto} provided for RankingGraphTypeV1.RankingGraphTypeV1`
      );
    }
    switch (dto.case) {
      case "STACKED_COLUMN":
        return RankingGraphTypeV1.STACKED_COLUMN;
      case "GROUPED_BAR":
        return RankingGraphTypeV1.GROUPED_BAR;
      case "NONE":
        return RankingGraphTypeV1.NONE;
      default:
        throw new InvalidRankingGraphTypeV1Error(
          `Case ${dto.case} is not valid case of RankingGraphTypeV1.RankingGraphTypeV1`
        );
    }
  };

  export const toDTO = (rankingGraphTypeV1: RankingGraphTypeV1): RankingGraphTypeV1DTO => {
    const enumDTO = {
      case: RankingGraphTypeV1[rankingGraphTypeV1],
    };
    return enumDTO;
  };
}

export class InvalidRankingGraphTypeV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingGraphTypeV1Error";
  }
}
export class InvalidRankingGraphTypeV1StackedColumnError extends InvalidRankingGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingGraphTypeV1StackedColumnError";
  }
}

export class InvalidRankingGraphTypeV1GroupedBarError extends InvalidRankingGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingGraphTypeV1GroupedBarError";
  }
}

export class InvalidRankingGraphTypeV1NoneError extends InvalidRankingGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRankingGraphTypeV1NoneError";
  }
}
